export class ResetPasswordOverrideModel {
    userName: string = "";
    newPassword: string = "";
    confirmNewPassword: string = "";
}
